<template>
  <div class="bundle-item mb-4">
    <!-- Bundle Header -->
    <div class="bundle-header">
      <div class="bundle-info">
        <CIcon name="cilLayers" class="mr-2"/>
        <strong>{{ bundleGroup.bundle.name }}</strong>
        <CBadge color="primary" class="ml-2">
          <translate translate-context="bundleitem.header">Bundle</translate>
        </CBadge>
      </div>
      <div class="bundle-price" v-if="showPrice">
        <strong>{{ bundleGroup.total_price | currency(order.currency) }}</strong>
      </div>
    </div>

    <!-- Bundle Description (if available) -->
    <div v-if="bundleGroup.bundle.description" class="bundle-description">
      {{ bundleGroup.bundle.description }}
    </div>

    <!-- Bundle Items -->
    <div class="bundle-items">
      <slot :items="bundleGroup.bundleItems"></slot>
    </div>
  </div>
</template>

<script>
import Filters from '@/domain/core/utils/filters'

export default {
  name: 'BundleItem',
  props: {
    bundleGroup: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    showPrice() {
      // Check for both edgeOrders and edgePrints permissions
      return this.hasPerm('edge.orders.total') || this.hasPerm('edge.print.total')
    }
  },
  filters: {
    currency: Filters.currency
  }
}
</script>

<style scoped>
.bundle-item {
  border: 2px solid #6c757d;
  border-radius: 12px;
  padding: 1rem;
  background: #f8f9fa;
}

.bundle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 2px solid #dee2e6;
}

.bundle-info {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
}

.bundle-price {
  font-size: 1.25rem;
  color: #2c3e50;
}

.bundle-description {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.bundle-items {
  /* Items inside bundle have less margin */
}

.bundle-items >>> .order-item {
  margin-bottom: 0.75rem;
  background: white;
}

.bundle-items >>> .order-item:last-child {
  margin-bottom: 0;
}
</style>
